@if(this.signals.fingerprintCapture.status() == 'failed'){
<div class="alert alert-danger text-tertiary-dark fs-9">
  {{ `app.pageId.biometric.messages.${this.signals.fingerprintCapture.statusMotive()?.key}` | translate: this.signals.fingerprintCapture.statusMotive()?.params }}
</div>
} @if(this.signals.fingerprintCapture.status() == 'invalid'){
<div class="alert alert-danger text-tertiary-dark fs-9">
  {{ `${this.signals.fingerprintCapture.statusMotive()?.key}` | translate: this.signals.fingerprintCapture.statusMotive()?.params }}
</div>
}
<section
  class="capture-fingerprint-container d-flex flex-row justify-content-center"
>
  @if(signals.fingerprintCapture.status() == 'validated'){
  <div
    class="d-flex flex-column gap-4 align-items-center justify-content-center"
    style="width: 70%"
  >
    <span
      class="fs-4 text-center text-success fw-semibold"
      style="line-height: 2rem"
      >{{ "app.pageId.biometric.messages.success" | translate }}</span
    >
    <div
      class="bg-primary-light p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
      style="width: 325px; height: 325px"
    >
      <div
        class="bg-primary p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
        style="width: 275px; height: 275px"
      >
        <div
          class="bg-primary-dark p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
          style="width: 225px; height: 225px"
        >
          <icon [icon]="iconCheck" size="150" color="primary-light" />
        </div>
      </div>
    </div>
  </div>

  } @else {
  <div class="capture-area d-flex flex-column gap-2">
    <header class="d-flex flex-row justify-content-between align-items-center">
      <span class="text-primary fs-5 fw-medium">{{
        "app.pageId.biometric.capture-fingerprint.fingerprint" | translate
      }}</span>
      @if(['captured', 'validating', 'validated',
      'invalid'].includes(signals.fingerprintCapture.status()!) ||
      (signals.fingerprintCapture.status() == 'failed' &&
      signals.fingerprintCapture.statusMotive()!.key ==
      'quality-threshold-not-fulfilled')){
      <div class="d-flex flex-row align-items-center gap-2">
        <span
          class="rounded-circle"
          [class.bg-success]="signals.fingerprintCapture.value()?.quality"
          [class.bg-tertiary]="signals.fingerprintCapture.status() == 'failed'"
          style="width: 10px; height: 10px"
        ></span>
        <span>{{
          "app.pageId.biometric.common.quality"
            | translate
              : { percent: signals.fingerprintCapture.value()?.quality }
        }}</span>
      </div>
      }
    </header>
    <main
      class="fingerprint-box d-flex align-items-center justify-content-center bg-info-light rounded-4 shadow-sm"
      style="position: relative; overflow: hidden; aspect-ratio: 5/6"
    >
      <div
        class="d-flex align-items-center justify-content-center"
        style="width: 100%; height: 100%; padding: 1rem 1.5rem"
      >
        <div
          class="bg-info-subtle"
          style="
            position: relative;
            width: 90%;
            height: 100%;
            border-radius: 55%;
            overflow: hidden;
          "
        >
          <!-- <div
            style="
              position: absolute;
              inset: 0;
              background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0.1) 50%,
                rgba(0, 0, 0, 0.1) 50%
              );
              z-index: 1;
            "
          ></div> -->
          <!-- <div
            style="
              position: absolute;
              inset: 0;
              z-index: 1;
              background: radial-gradient(
                circle,
                transparent 60%,
                rgba(0, 0, 0, 0.1) 100%,
                rgba(0, 0, 0, 0.1) 100%
              );
            "
          ></div> -->
          @if(['in-progress', 'retrying',
          'validating'].includes(signals.fingerprintCapture.status()!)){
          <div class="scanner-gradient-dark"></div>
          }

          <img
            priority
            alt="Huella dactilar"
            style="object-fit: cover; width: 100%; height: 100%"
            width="100"
            height="100"
            [src]="
              signals.fingerprintCapture.value() &&
              signals.fingerprintCapture.value()?.success
                ? `data:image/jpeg;base64,${signals.fingerprintCapture.value()?.fingerprint}`
                : 'assets/images/image-placeholder.svg'
            "
          />
        </div>
      </div>
      <!-- <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div> -->
    </main>
  </div>
  <div class="divider-vertical"></div>
  <div class="capture-options d-flex flex-column justify-content-center">
    <!-- <span class="fw-semibold pb-2"
      >{{
        "app.pageId.biometric.capture-fingerprint.finger-to-use" | translate
      }}:
    </span>
    <radio-component
      class="capture-radios-component"
      [config]="radioOptions()"
      (onRadioOptionSelected)="onRadioOptionSelected($event)"
    /> -->

    <span class="fw-medium pb-2 text-center d-flex flex-column align-items-center">
      @if(selectedCompanion()){
      {{
        "app.pageId.biometric.capture-face.indication-companion"
          | translate
      }}
      } @else {
      {{
        "app.pageId.biometric.capture-face.indication-patient"
          | translate
      }}
      }
      <button-component [config]="btns().biometricIndications" />
    </span>

    <div class="pt-3 d-flex flex-column gap-1">
      <button-component [config]="btns().validateCapture" />
      <button-component [config]="btns().capture" />
      <button-component [config]="btns().retryCapture" />
    </div>
  </div>
  }
</section>
